


export default {
  name: "SearchCircle",
  props: {
    perc: Number,
  },


  data() {
    return {
      percent: 0,
      completed: false,

    }
  },
  watch: {
    // perc(newVal, oldVal) {
    //   if (newVal === 100) {
    //     this.$emit('end', this.completed)
    //   }
    // }


  },
  methods: {
    runSearch() {
      let interval = setInterval( () => { if (this.percent < 100)this.percent += 1; else {this.completed = true; this.$emit('end', this.completed); clear()}}, 20 )
      function clear() {
        clearInterval(interval)
      }
    },

    tuggleProc() {
      if (this.perc === 100) {
        this.$emit('end', this.completed)
      }
    }


  },
  mounted() {
      // this.runSearch();
  }
}
